<div>
	<div class="dz-row data-row d-flex align-items-center header padding-bottom-object-2">
		<div class="dz-col-18 dz-block margin-top-object-4 dz-text-align-left">
			<span class="text-bold" dcrHTMLKey="MSCI_ESG_RATING_HEADER_LABEL">MSCI ESG RATING</span>
			<span class="margin-left-object-6" dcrHTMLKey="MSCI_ESG_RATING_SUB_HEADER_LABEL">CCC(worst) to AAA(best)</span>
		</div>
		<div class="dz-col-6 dz-block margin-top-object-4 dz-text-align-left">
			<span class="text-bold" dcrHTMLKey="MSCI_ESG_RATING_CATEGORY_LABEL">ESG Category</span>
		</div>
	</div>
	<div class="dz-row data-row d-flex align-items-center" *ngFor="let esg of esgRatingsMapping; let i = index">
		<div class="pull-left dz-text-align-left padding-vertical-8 padding-left-8" class="dz-col-6 dz-col-sm-6">
			<span>{{ esg.low }}</span>
		</div>
		<div class="pull-left dz-text-align-left padding-vertical-8 padding-left-8" class="dz-col-6 dz-col-sm-6">
			<span>{{ esg.high }}</span>
		</div>
		<div class="pull-left dz-text-align-left padding-vertical-8 padding-left-8" class="dz-col-6 dz-col-sm-6">
			<dz-icon type="arrow-right"></dz-icon>
		</div>
		<div class="pull-left dz-text-align-left padding-vertical-8 padding-left-8" class="dz-col-6 dz-col-sm-6">
			<span>{{ esg.category }}</span>
		</div>
	</div>
</div>
